import { Link, useParams } from "react-router";
import Button from "@/components/ui/button";

export default function NotFoundPage() {
	const { brandUrl } = useParams<{ brandUrl: string }>();

	return (
		<div className="flex items-center justify-center min-h-[calc(100vh-4rem)] bg-[#fafafa]">
			<div className="text-center max-w-md px-6">
				<div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={1.5}
						stroke="currentColor"
						className="w-8 h-8 text-gray-400"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
						/>
					</svg>
				</div>
				<h2 className="text-xl font-semibold text-primary mb-2">Page not found</h2>
				<p className="text-tertiary mb-6">
					The page you're looking for doesn't exist or may have been moved.
				</p>
				<Button as={Link} to={`/${brandUrl}/dashboard`} variant="default">
					Back to Dashboard
				</Button>
			</div>
		</div>
	);
}
